import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Button } from 'antd';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { useSessionOutcomeMutation } from '@hooks/useSessionOutcomeMutation';
import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';
import RTTModal from './RTTModal';
import { SessionFormItem } from '../../Components/SessionFormItem';

export const ReferralToTreatmentFormItem = () => {
  const { t } = useTranslation('common');
  const { appointment } = useSessionAppointment();

  const [open, setOpen] = useState(false);

  const [rtt] = useSessionFormState('Referral To Treatment');

  const { data: appointmentsMeta } = useAppointmentMeta();

  const { mutate } = useSessionOutcomeMutation();

  if (!appointmentsMeta?.appt_rtt) return null;

  return (
    <>
      <SessionFormItem
        name="Referral To Treatment"
        label={
          <>
            {t('RTT Status')}
            <Button
              disabled={appointment.read_only}
              data-testid="RTT-definition-button"
              onClick={() => setOpen(true)}
              css={{ fontSize: 'inherit' }}
              type="link"
            >
              <AiOutlineInfoCircle css={{ verticalAlign: 'middle', fontSize: 20 }} />
              &nbsp;Definition
            </Button>
          </>
        }
      >
        <Select
          defaultValue={rtt}
          disabled={appointment.read_only || appointment.appointment_completed}
          placeholder={t('Select RTT Status')}
          onChange={(value) =>
            mutate({
              rtt: value
            })
          }
          data-testid="rtt-status-select"
          options={appointmentsMeta.appt_rtt.map((item) => ({ label: item.appt_rtt_desc, value: item.appt_rtt_no }))}
        />
      </SessionFormItem>

      <RTTModal rttDef={open} setRttDef={setOpen} />
    </>
  );
};
